export default "__VITE_ASSET__CZKUq6Ze__"